import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.scss';

class Collapsable extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.node).isRequired,
    cutoff: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  expand() {
    this.setState({ expanded: true });
  }

  collapse() {
    this.setState({ expanded: false });
  }

  render() {
    if (this.props.items.length <= this.props.cutoff) {
      return <div className="Collapsable">{this.props.items}</div>;
    }
    const numberToShow = this.state.expanded
      ? this.props.items.length
      : this.props.cutoff;
    const itemsToShow = this.props.items.slice(0, numberToShow);
    const actionFunc = this.state.expanded
      ? this.collapse.bind(this)
      : this.expand.bind(this);
    const actionIcon = this.state.expanded
      ? 'fal fa-angle-up'
      : 'fal fa-angle-down';
    return (
      <div className="Collapsable">
        {itemsToShow}
        <i className={actionIcon} onClick={actionFunc}></i>
      </div>
    );
  }
}

export default Collapsable;
